import React from 'react';
import './AboutPage.css';

const AboutPage = () => {
    return (
        <div className="about-page">
            <section className="vision-section">
                <h2>About Us</h2>
                <p>Founded by Hamed Khan in 2021, Lets Make a Deal is a trusted real estate consultancy based in Bangalore. Working independently and in collaboration with top A-category builders, we specialize in seamless property deals and have a strong track record of successful sale closings.</p>
            </section>


            <div className="card-container">
                <section className="mission-section">
                    <h2>Our Mission</h2>
                    <p>We believe every experience to make a dream home should be a simple and successful transformation. To make this a possibility, we aim to continue building a dynamic market landscape through innovative strategies & new-age marketing tools.</p>
                    <p>This enables us to build a seamless value chain that encompasses end-users, industry stakeholders & investors.</p>
                </section>
                <section className=" about-section">
                    <h2>Our Vision</h2>
                    <p>Transparency in transactions and uniformity in contracts is our second name. We have a forte in real estate advisory and we believe every buying experience should be a simple and successful accomplishment from a DREAM to REALITY. The driving force behind it is our team of real estate advisors who have a zest for fundamental values of customer satisfaction, credibility and professionalism.</p>
                </section>
                <section className="goal-section">
                    <h2>Our Goal</h2>
                    <p>Lets Make A Deal is focused to help our clients "build value" by providing custom solutions for their real estate requirements.</p>
                </section>


            </div>
        </div>
    );
};

export default AboutPage;